export default "__VITE_ASSET__p$2utSqM__"